import React from 'react'
import { FaTools, FaClock, FaCheckCircle } from 'react-icons/fa'
import './Maintenance.css'

export default function Maintenance() {
  return (
    <div className="maintenance-page">
      <div className="maintenance-card">
        <div className="maintenance-badge">
          <span className="maintenance-dot"></span>
          Manutenção Programada
        </div>

        <div className="maintenance-icon-wrapper">
          <FaTools className="maintenance-icon" />
        </div>

        <h1 className="maintenance-title">Estamos em Manutenção</h1>
        <p className="maintenance-text">
          Estamos atualizando nossa plataforma com melhorias importantes para lhe proporcionar uma experiência ainda melhor. Voltaremos muito em breve!
        </p>

        <div className="maintenance-progress-bar">
          <div className="maintenance-progress-value"></div>
        </div>

        <div className="maintenance-footer">
          <div className="maintenance-footer-item">
            <FaClock style={{ color: '#71717a' }} />
            <span>Retorno em breve</span>
          </div>
          <div className="maintenance-footer-item">
            <FaCheckCircle style={{ color: '#10b981' }} />
            <span>Sistemas seguros</span>
          </div>
        </div>
      </div>
    </div>
  )
}
